import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navigation.css";
import Icon from "../assets/Icon.png";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  // Function to handle link click
  const handleLinkClick = () => {
    closeMenu();
    scrollToTop();
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    document.body.style.overflow = !isMenuOpen ? "hidden" : "auto";
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = "auto";
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    closeMenu();
  }, [location]);

  const isActive = (path) => location.pathname === path ? "active" : "";

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          {/* Logo/Brand with zoom effect */}
          <div className="brand-container">
            <Link to="/" className="nav-logo" onClick={handleLinkClick}>
              <img 
                src={Icon} 
                alt="Servite Counselling Centre" 
                className="logo-image zoom-icon"
              />
            </Link>
            <div className="brand-text-container">
              <Link to="/" className="brand-name" onClick={handleLinkClick}>
                Servite Counselling Centre
              </Link>
              <span className="brand-tagline">Empowering Hope, Healing Humanity</span>
            </div>
          </div>

          {/* Desktop Navigation with scroll to top */}
          <div className="desktop-nav">
            <div className="nav-links-container">
              <Link className={`nav-link ${isActive("/")}`} to="/" onClick={handleLinkClick}>Home</Link>
              <Link className={`nav-link ${isActive("/about")}`} to="/about" onClick={handleLinkClick}>About Us</Link>
              <Link className={`nav-link ${isActive("/services")}`} to="/services" onClick={handleLinkClick}>Services</Link>
              <Link className={`nav-link ${isActive("/programs")}`} to="/programs" onClick={handleLinkClick}>Programs</Link>
              <Link className={`nav-link ${isActive("/review")}`} to="/review" onClick={handleLinkClick}>Reviews</Link>
              <Link className={`nav-link ${isActive("/contact")}`} to="/contact" onClick={handleLinkClick}>Contact</Link>
            </div>
            <Link to="/contact" className="nav-cta-btn" onClick={handleLinkClick}>
              Book Appointment
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className="menu-bar"></span>
            <span className="menu-bar"></span>
            <span className="menu-bar"></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <div className={`mobile-menu-overlay ${isMenuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-container">
          <div className="mobile-menu-header">
            <div className="mobile-brand">
              <img 
                src={Icon} 
                alt="Servite Counselling Centre" 
                className="mobile-logo zoom-icon"
              />
              <div>
                <h3>Servite Counselling Centre</h3>
                <p>Nagercoil, Tamil Nadu</p>
              </div>
            </div>
            <button className="close-menu-btn" onClick={closeMenu} aria-label="Close menu">
              <span>&times;</span>
            </button>
          </div>

          <div className="mobile-nav-links">
            <Link className={`mobile-link ${isActive("/")}`} to="/" onClick={handleLinkClick}>
              Home
            </Link>
            <Link className={`mobile-link ${isActive("/about")}`} to="/about" onClick={handleLinkClick}>
              About Us
            </Link>
            <Link className={`mobile-link ${isActive("/services")}`} to="/services" onClick={handleLinkClick}>
              Our Services
            </Link>
            <Link className={`mobile-link ${isActive("/programs")}`} to="/programs" onClick={handleLinkClick}>
              Events & Programs
            </Link>
            <Link className={`mobile-link ${isActive("/review")}`} to="/review" onClick={handleLinkClick}>
              Client Reviews
            </Link>
            <Link className={`mobile-link ${isActive("/contact")}`} to="/contact" onClick={handleLinkClick}>
              Contact Us
            </Link>
          </div>

          <div className="mobile-cta-section">
            <Link to="/contact" className="mobile-cta-btn" onClick={handleLinkClick}>
              Book Appointment Now
            </Link>
          </div>
        </div>
      </div>

      {isMenuOpen && <div className="menu-backdrop" onClick={closeMenu} />}
    </>
  );
};

export default Navigation;